import { useSelector } from 'react-redux';
import FJMobileImageToImagePreset from './FJMobileImageToImagePreset';

const FJMobileImageToImagePresetContainer = () => {
    const creationList = useSelector(state => state.common.creationList);
    if (creationList?.length) return null;
    return <FJMobileImageToImagePreset creationList={creationList} />;
};
export default FJMobileImageToImagePresetContainer;
